import type { Testimonial } from '../types/content';

// Real client words — keep verbatim.
export const testimonials: Testimonial[] = [
  {
    name: 'Maria',
    location: 'Seattle, WA',
    focus: 'Birth Chart',
    excerpt: 'She predicted my engagement over a year ahead of time.',
    quote:
      'Abby takes the time to get to know you on a deep spiritual level. She helped me understand myself, my strengths and challenges in a way that made sense to me. She predicted my engagement over a year ahead of time and many more events that inspire me to push forward to my future.',
  },
  {
    name: 'Krista',
    location: 'Las Vegas, NV',
    focus: 'Career & Synastry',
    excerpt: 'She can easily tell me whether someone new I am dating is a good fit and whether it has long term potential.',
    quote:
      'I have come to Abby for advice about my career and when to expect challenges and how to face them. Abby has been the most helpful when it comes to my dating life. She can easily tell me whether someone new I am dating is a good fit and whether it has long term potential.',
  },
  {
    name: 'Jacob',
    location: 'Los Angeles, CA',
    focus: 'Future Forecast',
    excerpt: '…help me anticipate what kind of changes were coming in my future and how to prepare.',
    quote:
      'At first I was extremely skeptical how astrology could be useful for me in my life. I had only heard basic explanations that seemed applicable to any person. When I met Abby she explained how she would first get to know the blueprint of who I am and after that, help me anticipate what kind of changes were coming in my future and how to prepare.',
  },
];
